// extracted by mini-css-extract-plugin
export default {"iconWrapper":"_dc9c2642","icon":"_ee730311","facebook":"_ab4100b2","pinterest":"_e58e31ec"};